export function getAllClasses(state) {
  return state.knownClasses || [];
}



// WEBPACK FOOTER //
// ./src/app/api/redux-known-classes/known-class-selectors.js